<!--
 * @Descripttion: 饼图
 * @Author: zenghua.wang
 * @Date: 2021-08-30 10:10:47
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-11 17:59:24
-->
<template>
  <div
    ref="container"
    :class="setClass()"
    :style="styleSize"
    v-custom-loading="loading"
    :custom-loading-text="component.loadingText"
    :custom-loading-spinner="component.loadingSpinner"
    :custom-loading-background="component.loadingBackground"
  >
    <div
      :ref="id"
      :style="styleChart"
    ></div>
    <div
      :class="setClass('animation')"
      :style="styleActiveRing"
      v-if="option.animation && selected.name && selected.value"
    >
      <p :style="styleActiveTitle">{{selected.name}}</p>
      <div>
        <b :style="styleActiveValue">{{selected.value}}</b>
        <span :style="{color:option.labelShowColor}">{{option.unit}}</span>
      </div>
    </div>
  </div>
</template>
<script>
import bem from '@/dragComponents/mixins/bem'
import customLoading from '@/dragComponents/directive/loading'
import echart from '@/dragComponents/mixins/echart'
import {
  isEmpty,
  deepClone,
  isHasProp,
  setPx,
  setTooltipFormatter
} from '@/dragComponents/utils'
import { component } from '@/dragComponents/model/default.js'
import mock from '@/dragComponents/model/mock.js'

export default {
  name: 'drag-echart-pie',
  mixins: [bem, echart],
  directives: { customLoading },
  data() {
    return {
      component: component,
      selected: {
        name: null,
        value: null
      },
      animationIndex: 0,
      animationHandle: null
    }
  },
  computed: {
    len() {
      return !isEmpty(this.optionData.series)
        ? this.optionData.series[0]['data'].length
        : 0
    },
    styleActiveRing() {
      let width = this.height * (this.option.startRadius / 100)
      let height =
        this.option.activeTitleFontSize + this.option.activeValueFontSize
      return {
        width: setPx(width),
        left: this.option.activeLeft + '%',
        top: this.option.activeTop + '%',
        marginLeft: setPx(-width / 2),
        marginTop: setPx(-height / 2),
        textAlign: 'center'
      }
    },
    styleActiveTitle() {
      return {
        fontSize: setPx(this.option.activeTitleFontSize),
        color: this.option.activeTitleColor
      }
    },
    styleActiveValue() {
      return {
        fontSize: setPx(this.option.activeValueFontSize),
        color: this.option.activeValueColor
      }
    }
  },
  watch: {
    'option.animationTime'() {
      this.startAnimation()
    },
    'option.animation': {
      handler(val) {
        if (val) {
          this.startAnimation()
        } else {
          this.stopAnimation()
          clearInterval(this.animationHandle)
        }
      },
      immediate: true
    }
  },
  methods: {
    startAnimation() {
      if (isEmpty(this.optionData.series)) return
      let { animation, animationTime } = this.option
      let data = this.optionData.series[0]['data']
      clearInterval(this.animationHandle)
      if (animation) {
        this.animationHandle = setInterval(() => {
          const curr = this.animationIndex % this.len
          this.selected.name = data[curr]['name']
          this.selected.value = data[curr]['value']
          this.dragChart.dispatchAction({
            type: 'select',
            dataIndex: curr
          })
          this.dragChart.dispatchAction({
            type: 'downplay'
          })
          this.dragChart.dispatchAction({
            type: 'highlight',
            dataIndex: curr
          })
          this.animationIndex += 1
        }, animationTime)
      }
    },
    stopAnimation() {
      this.$nextTick(() => {
        if (this.dragChart) {
          this.dragChart.dispatchAction({
            type: 'unselect'
          })
          this.dragChart.dispatchAction({
            type: 'downplay'
          })
        }
      })
    },
    setOption() {
      const optionData = deepClone(this.optionData)
      let option = {
        title: isHasProp(
          this.option.titleShow,
          {
            text: this.option.titleText,
            subtext: this.option.titleSubtext,
            textStyle: {
              color: this.option.titleTextColor,
              fontSize: this.option.titleTextFontSize * (window?.scale || 1)
            },
            left: this.option.titleLeft || 'auto',
            top: this.option.titleTop || 'auto',
            subtextStyle: {
              color: this.option.titleSubtextColor,
              fontSize: this.option.titleSubtextFontSize * (window?.scale || 1)
            }
          },
          {}
        ),
        tooltip: isHasProp(
          !isEmpty(this.option.tipFormatter),
          {
            formatter: (params) => {
              return setTooltipFormatter(
                this.option.tipFormatter,
                params,
                this.dataList
              )
            }
          },
          {
            show: this.option.tipShow,
            textStyle: {
              fontSize: this.option.tipFontSize,
              color: this.option.tipColor
            }
          }
        ),
        legend: {
          show: this.option.legendShow,
          top: !isEmpty(this.option.legendTop)
            ? this.option.legendTop + '%'
            : 10,
          left: this.option.legendLeft,
          orient: this.option.legendOrient || 'horizontal',
          textStyle: {
            fontSize: this.option.legendFontSize
          },
          data: (() => {
            return (optionData.categories || []).map((ele, index) => {
              return {
                name: ele,
                textStyle: {
                  color: this.option.legendColor
                }
              }
            })
          })()
        },
        series: (() => {
          const list = (optionData.series || []).map((ele, index) => {
            return Object.assign(ele, {
              type: this.option.type,
              roseType: this.option.roseType ? 'radius' : '',
              selectedMode: 'single',
              radius: [
                this.option.radius ? this.option.startRadius + '%' : 0,
                this.option.endRadius + '%'
              ],
              center: [this.option.centerX + '%', this.option.centerY + '%'],
              animationType: 'scale',
              animationEasing: 'elasticOut',
              animationDelay: function(idx) {
                return Math.random() * 200
              },
              label: {
                normal: {
                  show: this.option.labelShow,
                  // formatter: '{b}: {c}',
                  formatter: ({ name, value }) => {
                    return !isEmpty(this.option.unit)
                      ? `${name}: ${value}${this.option.unit}`
                      : `${name}: ${value}`
                  },
                  textStyle: {
                    fontSize: this.option.labelShowFontSize,
                    color: this.option.labelShowColor,
                    fontWeight: this.option.labelShowFontWeight
                  }
                }
              },
              // 图形样式
              itemStyle: isHasProp(
                this.showColor(),
                {
                  color: (params) => this.getColor(params.dataIndex)
                },
                {
                  // borderRadius: this.option.borderRadius,
                  // borderColor: this.option.borderColor,
                  // borderWidth: this.option.borderWidth,
                  emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                }
              ),
              data: (() => {
                let dlist = ele.data
                if (this.option.notCount) {
                  dlist = dlist.filter((ele) => {
                    if (ele.value && ele.value !== 0) {
                      return true
                    }
                  })
                }
                if (this.option.sort) {
                  dlist.sort(function(a, b) {
                    return a.value - b.value
                  })
                } else {
                  dlist.sort(function(a, b) {
                    return b.value - a.value
                  })
                }
                return dlist
              })()
            })
          })
          return list
        })()
      }

      // 颜色设置
      // if (this.option.defaultColor) {
      //   option.color && delete option.color
      // } else {
      //   option.color = this.option.color
      // }

      this.dragChart.off('mouseover')
      this.dragChart.off('mouseout')

      this.dragChart.on('mouseover', () => {
        clearInterval(this.animationHandle)
        this.stopAnimation()
      })
      this.dragChart.on('mouseout', () => {
        this.animationIndex = 0
        this.startAnimation()
      })

      // console.log('pie=', option, this.option)
      this.dragChart.resize()
      this.dragChart.setOption(option, true)
      this.isChart = true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init(mock.echart.series, mock.echart.categories)
      this.startAnimation()
    })
  }
}
</script>
<style lang="scss" scoped>
@import '@/dragComponents/styles/echart/index.scss';
</style>
